import React, { useCallback, useMemo } from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

import {
  MESSAGE_BTN_ACTION,
  MESSAGE_STATE,
} from 'src/containers/Chat/constants'
import { PATH as KARTE_PLAN_PATH } from 'src/pages/kartePlan'
import LocalStorage from 'src/utils/LocalStorage'
import { useAppSelector } from 'src/store'
import { USER_TREATMENT_STATE } from 'src/enum/userTreatmentState'

interface Props {
  item: {
    message_content: string
  }
}

const ButtonMessage = (props: Props) => {
  const { message_content } = props.item
  const content = useMemo(() => {
    try {
      return JSON.parse(message_content)
    } catch {
      return {}
    }
  }, [message_content])

  const userTreatments = useAppSelector(
    (state) => state.domain.myPage.userTreatment.entities,
  )

  const userTreatment = useMemo(() => {
    if (userTreatments) {
      return userTreatments.find(
        (userTreatment) => userTreatment.id === content.user_treatment_id,
      )
    }
  }, [userTreatments, content.user_treatment_id])

  const navigate = useNavigate()

  const handleRedirectKartePlan = useCallback(() => {
    if (!content?.doctor_feedback_id || !content?.user_treatment_id) return

    LocalStorage.setUserTreatmentId(content.user_treatment_id)
    navigate(
      KARTE_PLAN_PATH.PRESCRIPTION_PROPOSAL.replace(
        ':id',
        content.doctor_feedback_id,
      ),
    )
  }, [navigate, content?.doctor_feedback_id, content?.user_treatment_id])

  const isDisabledBtnPrescription = useMemo(() => {
    const localStorageUtId = Number(LocalStorage.getUserTreatmentId())
    const lastFeedbackId = userTreatment?.last_doctor_feedback?.id
    const userTreatmentState = userTreatment?.state as unknown as string

    return (
      localStorageUtId !== content.user_treatment_id ||
      content.state !== MESSAGE_STATE.COMPLETED ||
      userTreatmentState !== USER_TREATMENT_STATE.CONFIRMING_PRESCRIPTION ||
      lastFeedbackId !== content.doctor_feedback_id
    )
  }, [
    content.user_treatment_id,
    content.state,
    content.doctor_feedback_id,
    userTreatment,
  ])

  const renderContent = useMemo(() => {
    switch (content.action) {
      case MESSAGE_BTN_ACTION.COMPLETED_FEEDBACK:
        return (
          <div>
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className={`btn-size btn btn-primary ${
                  isDisabledBtnPrescription ? 'disabled' : 'cursor-pointer'
                }`}
                onClick={handleRedirectKartePlan}
                disabled={isDisabledBtnPrescription}
              >
                次のステップへ進む
              </button>
            </div>
          </div>
        )
      default:
        return <div />
    }
  }, [content.action, isDisabledBtnPrescription, handleRedirectKartePlan])

  return <Wrapper>{renderContent}</Wrapper>
}

const Wrapper = styled.div`
  .cursor-pointer {
    cursor: pointer;
  }

  .disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .btn-size {
    height: 40px;
  }
`

export default ButtonMessage
